import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import { Link } from '@ipfabric/ui-components/Link/Link';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { getSiteSeparationWithDefaults } from './siteSeparationDefaults';

type ManualSiteSeparationFieldValues = {
  manualSiteSeparationEnabled: boolean;
};

export const manualSiteSeparation: FormSnippet<
  DiscoverySettingsObject,
  ManualSiteSeparationFieldValues
> = {
  render: ({ form }) => (
    <FormSwitch
      control={form.control}
      name='manualSiteSeparationEnabled'
      label='Manual site separation'
      labelTooltip={
        <span>
          The manual site separation respects the <code>siteName</code> device
          attribute that can be set in the Device Attributes table.
        </span>
      }
      description='If enabled, this rule will be run before any other rules listed below.'
      helperText={
        <Link
          renderAs='link'
          to='/settings/discovery-snapshots/global-discovery-configuration/device-attributes'
        >
          Configure device attributes
        </Link>
      }
    />
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.manualSiteSeparationEnabled =
      model.siteSeparation?.manualEnabled ?? true;
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.siteSeparation = {
      ...getSiteSeparationWithDefaults(modelDraft.siteSeparation),
      manualEnabled: transformedValues.manualSiteSeparationEnabled,
    };
  },
  schema: z.object({
    manualSiteSeparationEnabled: z.boolean(),
  }),
};
